module.exports = "../images/smallmouth-bass-fishing-ontario.jpg?v=7812727";